import classNames from "classnames";
import classes from "~/features/lms/components/LmsModalStyles.module.less";
import Modal from "~/common/components/Modal";
import { Button } from "~/common/mui";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

export const LmsNotApprovedModal = (props: Props) => {
  const isMinTablet = useIsMinTabletSize();
  const { t } = useTranslation();
  return (
    <Modal
      onClose={props.onClose}
      footerChildren={<Button onClick={props.onConfirm}>{t("feature.lms.modal.button.ok")}</Button>}
    >
      <p className={classNames(classes.root)}>
        <Trans i18nKey="feature.lms.modal.not_approved.text" />
      </p>
    </Modal>
  );
};
